import fetch from '@/common/axios/fetch.js'

const MEMBER = `Member/`

/**
 * 我的书架
 * @param uid			#用户id
 * @param token		#用户token
 * @param page 页数，默认值为1
 * @param pageSize 每页数量
 * @returns {Object} data
 */
export function myBookRank(page, pageSize) { // uid, token,
	return fetch({
		url: `${MEMBER}myBookRank`,
		method: 'get',
		params: {
			// uid,
			// token,
			page,
			pageSize
		}
	})
}

/**
 * 添加书籍到书架
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 书籍id
 * @returns {Object} data
 */
export function addBookRank(id) { // uid, token,
	return fetch({
		method: 'post',
		url: `${MEMBER}addBookRank`,
		data: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 从书架中删除书籍
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 书籍id
 * @returns {Object} data
 */
export function deleteFromBookRank(id) { // uid, token,
	return fetch({
		method: 'post',
		url: `${MEMBER}deleteFromBookRank`,
		data: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 我的阅读历史
 * @param uid			#用户id
 * @param token		#用户token
 * @param page 页数，默认值为1
 * @param pageSize 每页数量
 * @returns {Object} data
 */
export function readHistory(page, pageSize) { // uid, token,
	return fetch({
		url: `${MEMBER}readHistory`,
		method: 'get',
		params: {
			// uid,
			// token,
			page,
			pageSize
		}
	})
}

/**
 * 删除阅读历史
 * @param uid			#用户id
 * @param token		#用户token
 * @returns {Object} data
 */
export function deleteReadHistory() {
	return fetch({
		method: 'get',
		url: `${MEMBER}deleteReadHistory`
	})
}

/**
 * 我的评论
 * @param uid			#用户id
 * @param token		#用户token
 * @param page 页数，默认值为1
 * @param pageSize 每页数量
 * @returns {Object} data
 */
export function comment( page, pageSize) { // uid, token,
	return fetch({
		url: `${MEMBER}comment`,
		method: 'get',
		params: {
			// uid,
			// token,
			page,
			pageSize
		}
	})
}

/**
 * 添加评论
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 书籍id
 * @param content #评论内容，字数不能超过100
 * @param score #评分
 * @param cid 文章评论
 * @returns {Object} data
 */
export function addComment(id, content, score, cid) { //  // uid, token,
	return fetch({
		method: 'post',
		url: `${MEMBER}addComment`,
		data: {
			// uid,
			// token,
			id,
			content,
			score,
			cid
		}
	})
}

/**
 * 删除评论
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 评论编号id
 * @returns {Object} data
 */
export function deleteComment(id) { //uid, token,
	return fetch({
		method: 'post',
		url: `${MEMBER}deleteComment`,
		data: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 删除评论
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 评论编号id
 * @returns {Object} data
 */
export function doLike(id) { // uid, token,
	return fetch({
		method: 'post',
		url: `${MEMBER}doLike`,
		data: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 获取消息列表
 * @param uid			#用户id
 * @param token		#用户token
 * @param page 页数，默认值为1
 * @param pageSize 每页数量
 * @returns {Object} data
 */
export function noticeList(page, pageSize) { // uid, token,
	return fetch({
		url: `${MEMBER}noticeList`,
		method: 'get',
		params: {
			// uid,
			// token,
			page,
			pageSize
		}
	})
}

/**
 * 获取消息详情
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 评论编号id
 * @returns {Object} data
 */
export function noticeDetail(id) { // uid, token,
	return fetch({
		url: `${MEMBER}noticeDetail`,
		method: 'get',
		params: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 删除
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 评论编号id
 * @returns {Object} data
 */
export function deleteNotice(id) { // uid, token,
	return fetch({
		method: 'post',
		url: `${MEMBER}deleteNotice`,
		data: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 获取消息详情
 * @param uid			#用户id
 * @param token		#用户token
 * @param id 评论编号id
 * @returns {Object} data
 */
export function markRead(id) { // uid, token,
	return fetch({
		url: `${MEMBER}markRead`,
		method: 'get',
		params: {
			// uid,
			// token,
			id
		}
	})
}

/**
 * 检测用户是否是VIP
 */
export function isVip() {
	return fetch({
		method: 'get',
		url: `${MEMBER}isVip`
	})
}

/**
 * 获取vip配置信息
 */
export function getVipConfig() {
	return fetch({
		method: 'get',
		url: `${MEMBER}getVipConfig`
	})
}

/**
 * 是否登录
 */
export function isLogin() {
	return fetch({
		method: 'get',
		url: `${MEMBER}isLogin`,
        params: {
            // uid,
            // token
        }
	})
}

/**
 * 获取充值套餐
 */
export function rechargeConfig() {
	return fetch({
		method: 'get',
		url: `${MEMBER}rechargeConfig`
	})
}

/**
 * 优惠券兑换接口
 * @param coupon
 */
export function useCoupon(coupon) {
	return fetch({
		method: 'get',
		url: `${MEMBER}useCoupon`,
		params: {
			coupon
		}
	})
}
/**
 * 签到信息
 * @param {*} id
 */
export function SignIn(id) {
	return fetch({
		url: 'https://bsm.cangqiongkanshu.com//api/checkin/info',
		method: 'get',
		params: {
			id
		}
	})
}





// WEBPACK FOOTER //
// ./src/common/api/member.js